// extracted by mini-css-extract-plugin
export default {"skeleton-select":"LOnOGG","skeleton-select__wrapper":"l3mN00"};